export const cablecarActions = () => (next) => (action) => {
  if (action.meta?.__cablecar__) {
    const { payload, ...rest } = action
    return next({ ...rest, ...payload })
  }

  return next(action)
}
